const padWithLeadingZero = (duration: number) => {
    return Number(duration) >= 0 ? duration.toString().padStart(2, "0") : "";
};

const secondsInMinute = 60;
const secondsInHour = secondsInMinute * 60;
const secondsInDay = secondsInHour * 24;
const secondsInMonth = secondsInDay * 30;

export const getDurationByComponents = (seconds: number, minutes: number, hours = 0, days = 0, months = 0) =>
    months * secondsInMonth + days * secondsInDay + hours * secondsInHour + minutes * secondsInMinute + seconds;

export const getMonths = (duration: number) => {
    return Math.floor(duration / secondsInMonth);
};

export const getAbsoluteDays = (duration: number) => {
    return padWithLeadingZero(Math.floor(duration / secondsInDay));
};

export const getDays = (duration: number) => {
    return padWithLeadingZero(Math.floor((duration % secondsInMonth) / secondsInDay));
};

export const getHours = (duration: number) => {
    return padWithLeadingZero(Math.floor((duration % secondsInDay) / secondsInHour));
};

export const getMinutes = (duration: number) => {
    return padWithLeadingZero(Math.floor((duration % secondsInHour) / secondsInMinute));
};

export const getSeconds = (duration: number) => {
    return padWithLeadingZero(Math.ceil(duration % secondsInMinute));
};
